const SearchResultsHook = {
  mounted() {
    // Handle scroll to selected item when selection changes
    this.handleEvent("scroll-to-selected", (event) => {
      const { selectedIndex } = event;
      
      // Find all result items
      const resultItems = this.el.querySelectorAll('[data-result-index]');
      
      if (resultItems[selectedIndex]) {
        const selectedItem = resultItems[selectedIndex];
        const container = this.el;
        
        // Get positions
        const containerTop = container.scrollTop;
        const containerBottom = containerTop + container.clientHeight;
        const itemTop = selectedItem.offsetTop;
        const itemBottom = itemTop + selectedItem.offsetHeight;
        
        // Check if item is outside visible area
        if (itemTop < containerTop) {
          // Item is above visible area, scroll up
          container.scrollTop = itemTop;
        } else if (itemBottom > containerBottom) {
          // Item is below visible area, scroll down
          container.scrollTop = itemBottom - container.clientHeight;
        }
      }
    });
  }
};

export default SearchResultsHook;
